import React from "react";
import { StyleSheet, View } from "react-native";
import { User } from "lucide-react";
import CustomText from "../../../common/general/CustomText/CustomText";

interface PersonalOnlyContentProps {
  connectorName: string;
}

export function PersonalOnlyContent({ connectorName }: PersonalOnlyContentProps) {
  return (
    <View
      style={[
        styles.alertBox,
        {
          backgroundColor: "#E0F2FE",
          borderColor: "#38BDF8",
          display: "flex",
          flexDirection: "row",
          gap: 10,
        },
      ]}>
      <View style={{ paddingTop: 4 }}>
        <User size={16} color="#075985" />
      </View>
      <CustomText
        text={`${connectorName} is connected by individual users in their personal settings - it cannot be configured here.`}
        size="sm"
        useTranslationText={false}
        textType="text"
        style={{ color: "#075985" }}
        weight="normal"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  alertBox: {
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 10,
    paddingVertical: 10,
    marginTop: 20,
  },
});
